import React from "react";

import { Box, useMediaQuery } from "@mui/material";

import CustomPieChart from "../../../../components/customPieChart/CustomPieChart";

const BoxDistributionDevices = ({ data }) => {
  const isMobile = useMediaQuery("(max-width:600px)");

  const parsedDataset = Object.entries(data).map(([device, value]) => ({
    label: device,
    value: Number(value),
  }));

  return (
    <Box
      sx={{
        justifyContent: "center", // Centra orizzontalmente
        alignSelf: "center", // Centra verticalmente
      }}
    >
      <CustomPieChart
        dataset={parsedDataset}
        width={isMobile ? 250 : 300}
        height={isMobile ? 350 : 300}
      />
    </Box>
  );
};

export default BoxDistributionDevices;
